module.exports = __webpack_public_path__ + "static/img/tap-right-0.b2af788.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/tap-right-0.png
// module id = nr02
// module chunks = 1